import { LoginForm } from './LoginForm';

export function AuthPage() {
  return <LoginForm />;
}
